import { render, staticRenderFns } from "./ADoorColorSelector.vue?vue&type=template&id=5e41c6f0&"
import script from "./ADoorColorSelector.vue?vue&type=script&lang=js&"
export * from "./ADoorColorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports